import React from 'react';
import PageModalTitle from 'Views/Page/Content/Modal/Components/PageModalTitle';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';

const DialogTitle = () => {
  return (
    <PageModalTitle>
      <FDStack direction="column" alignItems="flex-start" justifyContent="flex-start">
        <MetaField attr="name" />
        <MetaField attr="informationText" />
      </FDStack>
    </PageModalTitle>
  );
};

export default DialogTitle;
